import { connect } from 'react-redux';

import {
  selectAdminContactUsRecipients,
  selectAdminContactUsRecipientsLoading,
} from 'selectors/contactUsSelectors';
import { selectIsAdmin, selectIsLoggedIn } from 'selectors/authenticationSelectors';
import {
  createContactUsRecipient,
  getAdminContactUsRecipients,
  updateContactUsRecipient,
} from 'actions/thunks/contactUs';
import SystemSettingsPage from 'components/pages/admin/SystemSettingsPage';

const mapStateToProps = (state) => ({
  contactUsRecipients: selectAdminContactUsRecipients(state),
  contactUsRecipientsLoading: selectAdminContactUsRecipientsLoading(state),
  isAdmin: selectIsAdmin(state),
  isLoggedIn: selectIsLoggedIn(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAdminContactUsRecipients: () => dispatch(getAdminContactUsRecipients()),
  createContactUsRecipient: (recipient) => dispatch(createContactUsRecipient(recipient)),
  updateContactUsRecipient: (recipient) => dispatch(updateContactUsRecipient(recipient)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SystemSettingsPage);
